export default "__VITE_ASSET__DQPB1etC__"